module.exports = __webpack_public_path__ + "img/wwq.7072dea9.png";